import script from "./MenuItemDetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuItemDetailsModal.vue?vue&type=script&setup=true&lang=ts"

import "./MenuItemDetailsModal.vue?vue&type=style&index=0&id=5b5b228b&lang=scss"

const __exports__ = script;

export default __exports__